import React, { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { InputLabel, SharableLink } from '@app/form';
import { QuestionTooltip } from 'components';
import { UnmoderatedTaskSetting, useShortUrl, useTaskSetting } from 'queries';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  label: {
    marginTop: theme.marginBase * 2,
  },
  link: {
    width: '100%',
  },
}));

interface Props {
  name: string;
  taskSettingId?: string;
}

const urls: Record<string, string> = {
  completed: '/study/complete/:completedCode',
  finished: '/study/finish/:finishedCode',
  notSerious: '/study/notSerious/:reportedCode',
  technical: '/study/technical/:reportedCode',
  lied: '/study/lied/:reportedCode',
  quotafull: '/study/quotafull/:reportedCode',
  screenout: '/study/screenout/:reportedCode',
  legal: '/study/legal/:reportedCode',
  duplicate: '/study/duplicate/:reportedCode',
  quality: '/study/quality/:reportedCode',
};

export const RedirectionLink = ({ name, taskSettingId }: Props) => {
  const { data: ts } = useTaskSetting<UnmoderatedTaskSetting>(taskSettingId);
  const shortUrl = useShortUrl();
  const classes = useStyles();
  const { t } = useTranslation();

  const route = urls[name];

  const url = useMemo(() => {
    if (!ts) {
      return null;
    }
    return `${shortUrl}${route}?tid={{tid}}`
      .replace(':completedCode', ts.completedCode)
      .replace(':finishedCode', ts.finishedCode)
      .replace(':reportedCode', ts.reportedCode);
  }, [route, ts, shortUrl]);

  if (!url) {
    return null;
  }
  return (
    <label>
      <InputLabel
        label={t(
          `editSession.linkConfiguration.studyLinkConfiguration.links.${name}.label`,
        )}
        rightAction={
          <QuestionTooltip
            title={t(
              `editSession.linkConfiguration.studyLinkConfiguration.links.${name}.help`,
            )}
          />
        }
      />
      <SharableLink link={url} className={classes.link} />
    </label>
  );
};
